import { useCallback } from 'react';
import { CustomVizOptionsSummaryDropdown } from 'libs/end-to-end/src/custom-viz/CustomVizDefinitions';
import { CustomVizHookDropdownOptionsFilterByIdFn } from 'apps/sigma2-ui/src/lib/custom-viz/types';
import { Setter } from 'libs/end-to-end/src/ui-types';

export const usePayBenchmarkingOnRoleSelectedActions = ({
  filteredCustomVizDropdowns,
  setSelectedRole,
  setSelectedLevel,
  setSelectableLevels,
}: {
  filteredCustomVizDropdowns: CustomVizHookDropdownOptionsFilterByIdFn;
  setSelectedRole: Setter<string | null>;
  setSelectedLevel: Setter<string | null>;
  setSelectableLevels: Setter<CustomVizOptionsSummaryDropdown[]>;
}) => {
  // Whenever a role gets selected, we need to update the selectable levels
  // to only show the levels that are available for that role.
  return useCallback(
    (role: string | null) => {
      setSelectedRole(role);

      if (role === null) {
        setSelectedLevel(null);
        setSelectableLevels([]);
        return;
      }

      const levelDropdownsToDisplay = filteredCustomVizDropdowns(
        `job_level_${role}`,
      );
      setSelectableLevels(levelDropdownsToDisplay);
    },
    [
      setSelectedRole,
      filteredCustomVizDropdowns,
      setSelectableLevels,
      setSelectedLevel,
    ],
  );
};
